import React from 'react';
import { connect } from 'formik';
import { injectIntl } from 'react-intl';

import './checkout-summary-panel.scss';


const DateIcon = (
	<svg width="24px" height="26px" viewBox="0 0 24 26">
		<g id="website_v2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" fillOpacity="0.2">
			<g id="the_tour" transform="translate(-990.000000, -356.000000)" fill="#142428" fillRule="nonzero">
				<g id="calendar-outline" transform="translate(990.000000, 356.000000)">
					<path d="M19.5,3 L18.25,3 L18.25,1.75 C18.25,1.05964406 17.6903559,0.5 17,0.5 C16.3096441,0.5 15.75,1.05964406 15.75,1.75 L15.75,3 L8.25,3 L8.25,1.75 C8.25,1.05964406 7.69035594,0.5 7,0.5 C6.30964406,0.5 5.75,1.05964406 5.75,1.75 L5.75,3 L4.5,3 C2.42893219,3 0.75,4.67893219 0.75,6.75 L0.75,21.75 C0.75,23.8210678 2.42893219,25.5 4.5,25.5 L19.5,25.5 C21.5710678,25.5 23.25,23.8210678 23.25,21.75 L23.25,6.75 C23.25,4.67893219 21.5710678,3 19.5,3 Z M4.5,5.5 L5.75,5.5 L5.75,6.75 C5.75,7.44035594 6.30964406,8 7,8 C7.69035594,8 8.25,7.44035594 8.25,6.75 L8.25,5.5 L15.75,5.5 L15.75,6.75 C15.75,7.44035594 16.3096441,8 17,8 C17.6903559,8 18.25,7.44035594 18.25,6.75 L18.25,5.5 L19.5,5.5 C20.1903559,5.5 20.75,6.05964406 20.75,6.75 L20.75,11.75 L3.25,11.75 L3.25,6.75 C3.25,6.05964406 3.80964406,5.5 4.5,5.5 Z M19.5,23 L4.5,23 C3.80964406,23 3.25,22.4403559 3.25,21.75 L3.25,14.25 L20.75,14.25 L20.75,21.75 C20.75,22.4403559 20.1903559,23 19.5,23 Z" id="Shape" />
					<circle id="Oval" cx="7" cy="18" r="1.25" />
					<path d="M17,16.75 L12,16.75 C11.3096441,16.75 10.75,17.3096441 10.75,18 C10.75,18.6903559 11.3096441,19.25 12,19.25 L17,19.25 C17.6903559,19.25 18.25,18.6903559 18.25,18 C18.25,17.3096441 17.6903559,16.75 17,16.75 Z" id="Path" />
				</g>
			</g>
		</g>
	</svg>

);

const CheckIcon = (
	<svg width="17px" height="15px" viewBox="0 0 17 15">
		<g id="website_v2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
			<g id="step3+experiences" transform="translate(-860.000000, -597.000000)" stroke="#142428" strokeWidth="2">
				<g id="Group-8" transform="translate(834.000000, 223.000000)">
					<g id="Group-5" transform="translate(27.000000, 368.000000)">
						<polyline id="Path-4" points="0.140437681 13.5 5.70308615 19.0626485 14.3393218 7.42641285" />
					</g>
				</g>
			</g>
		</g>
	</svg>
);

const ExtraInfoLine = ({ icon, title, label }) => (
	<div className="extra-info-line">
		<div className="extra-info-icon">
			{icon}
		</div>

		<div className="extra-info-description">
			<h4>{title}</h4>

			<span>{label}</span>
		</div>
	</div>
);

const CheckoutSummaryPanel = ({ formik, intl }) => {
	const {
		name, selectedMethod, prices, extras, schedule,
	} = formik.values;

	function getEmailAndSMSPrice() {
		return selectedMethod === 'email+sms' ? 2 : 0;
	}

	function getPrice(amount, quantity) {
		return amount * quantity;
	}

	function getTotalPrice() {
		const ticketsSum = prices.reduce(
			(accumulator, currentValue) => accumulator + getPrice(currentValue.value, currentValue.quantity),
			0,
		);

		const extrasSum = extras.reduce(
			(accumulator, currentValue) => accumulator + getPrice(currentValue.price, currentValue.quantity),
			0,
		);

		return ticketsSum + extrasSum + getEmailAndSMSPrice();
	}

	return (
		<div>
			<div className="checkout-summary-panel">
				<div className="section title">
					<h4>{name || ''}</h4>
				</div>

				{schedule && schedule.day && (
					<div className="section date">
						{DateIcon}

						<span>{schedule.day.format('DD MMMM')}</span>
						{schedule.time && <span>{`, ${schedule.time}`}</span>}
					</div>
				)}

				<div className="section items">
					<div className="items-list">
						{prices.map(price => (
							price.quantity > 0 && (
								<div className="item row">
									<span className="col-xs-9">
										{`${intl.formatMessage({ id: 'checkout.panel.ticket' }, { value: price.name })} x ${price.quantity}`}
									</span>
									<span className="col-xs-3 end-xs">
										{`${getPrice(price.value, price.quantity)}€`}
									</span>
								</div>
							)
						))}
					</div>
				</div>

				{(extras.reduce((accumulator, currentValue) => accumulator + currentValue.quantity, 0) > 0) && (
					<div className="section items">
						<div className="items-list">
							{extras.map(extra => (
								extra.quantity > 0 && (
									<div className="item row">
										<span className="col-xs-9">
											{`${extra.name} x ${extra.quantity}`}
										</span>
										<span className="col-xs-3 end-xs">
											{`${getPrice(extra.price, extra.quantity)}€`}
										</span>
									</div>
								)
							))}

						</div>
					</div>
				)}

				{selectedMethod === 'email+sms' && (
					<div className="section items">
						<div className="items-list">
							<div className="item row">
								<span className="col-xs-9">{intl.formatMessage({ id: 'checkout.panel.email-more-ticket' })}</span>
								<span className="col-xs-3 end-xs">{`${getEmailAndSMSPrice()}€`}</span>
							</div>
						</div>
					</div>
				)}

				<div className="section total">
					<div className="row">
						<span className="col-xs">{intl.formatMessage({ id: 'checkout.panel.total' })}</span>
						<span className="col-xs end-xs total-number">{`${getTotalPrice()}€`}</span>
					</div>
				</div>
			</div>

			<div className="extra-info-panel">
				<ExtraInfoLine
					icon={CheckIcon}
					title={intl.formatMessage({ id: 'checkout.panel.instant-confirmation' })}
					label={intl.formatMessage({ id: 'checkout.panel.instant-confirmation.label' })}
				/>
			</div>
		</div>
	);
};

export default injectIntl(connect(CheckoutSummaryPanel));
